var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont icon-container",class:[_vm.icon]})
}
var staticRenderFns = []

export { render, staticRenderFns }